import { useCallback, useRef } from "react";

/**
 * 一个不需要管理依赖的 useCallback 缓存函数
 * 传入的被包装函数，将永远保持最新的外部引用状态，
 * 且包装后的函数索引将永远不会发生变化。因此，就不必再关心callback函数的依赖问题了。
 * @param {(...args: any[]) => any} callback
 * @returns
 */
export function useCallbackStatic(callback) {
  var proxyRef = useRef(callback);
  proxyRef.current = callback;
  var staticCachedCall = useCallback(function () {
    return proxyRef.current.apply(proxyRef, arguments);
  }, []);
  return staticCachedCall;
}